
import React from 'react';
import { UseFormReturn } from "react-hook-form";
import { TerraceFormValues } from "./types";
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import TerraceTypeSelect from './TerraceTypeSelect';
interface TerraceBasicInfoProps {
  form: UseFormReturn<TerraceFormValues>;
  disabled?: boolean;
}
const TerraceBasicInfo: React.FC<TerraceBasicInfoProps> = ({
  form,
  disabled = false
}) => {
  return <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={form.control} name="name" render={({
        field
      }) => <FormItem>
              <FormLabel>Name *</FormLabel>
              <FormControl>
                <Input placeholder="Enter terrace name" {...field} disabled={disabled} className={disabled ? "bg-muted text-muted-foreground" : ""} />
              </FormControl>
              {disabled && <FormDescription>
                  This will be filled automatically from the Google Maps link
                </FormDescription>}
              <FormMessage />
            </FormItem>} />

        <TerraceTypeSelect form={form} disabled={disabled} />
      </div>

      {/* Address and Google Maps URL fields side by side on desktop */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={form.control} name="address" render={({
        field
      }) => <FormItem>
              <FormLabel>Address *</FormLabel>
              <FormControl>
                <Input placeholder="Enter full address" {...field} disabled={disabled} className={disabled ? "bg-muted text-muted-foreground" : ""} />
              </FormControl>
              {disabled && <FormDescription>
                  This will be filled automatically from the Google Maps link
                </FormDescription>}
              <FormMessage />
            </FormItem>} />
        <FormField control={form.control} name="googleMapsUrl" render={({
        field
      }) => <FormItem>
              <FormLabel>Google Maps URL</FormLabel>
              <FormControl>
                <Input
                  type="url"
                  inputMode="url"
                  autoComplete="off"
                  readOnly
                  tabIndex={-1}
                  placeholder="Will be filled from link"
                  {...field}
                  className="bg-muted text-muted-foreground cursor-not-allowed"
                />
              </FormControl>
              {/* <FormDescription>
                This will be filled automatically from the Google Maps link you provide above. You cannot edit it manually.
              </FormDescription> */}
              <FormMessage />
            </FormItem>} />
      </div>
    </div>;
};
export default TerraceBasicInfo;
